import React, { FC } from 'react';
import { Typography } from '@mui/material';

interface OrderItemProps {
  title: string;
  count: number;
  price: string;
}

const OrderItem: FC<OrderItemProps> = ({ title, count, price }) => {
  return (
    <>
      <Typography
        sx={{
          fontSize: { xs: '16px', sm: '20px' },
          lineHeight: { xs: '19px', sm: '23px' },
          fontWeight: { xs: '600', sm: '400' },
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: '14px', sm: '20px' },
          lineHeight: { xs: '16px', sm: '23px' },
          fontWeight: '500',
          justifySelf: 'center',
        }}
      >
        {count}
      </Typography>

      <Typography
        sx={{
          fontSize: { xs: '14px', sm: '20px' },
          lineHeight: { xs: '16px', sm: '23px' },
          fontWeight: '300',
          justifySelf: 'flex-end',
        }}
      >
        {price}
      </Typography>
    </>
  );
};

export default OrderItem;
